import { Task } from './task.model';

const REVIEWED_AT = '2023-10-02T11:00:00Z';
const SUPPORTING_TEXT = 'Supporting text contenct here';
const LATE_CREATED_AT = '2023-10-02T23:30:00Z';
const LATE_READ_AT = '2023-10-02T11:30:00Z';

export interface notifications {
  createdOn: Date;
  id: number;
  message: string;
  read: Date | undefined;
  selected?: boolean;
  task?: Task;
  title: string;
}

export const bad_notification: notifications = {
  id: 1,
  title: 'Error Loading',
  message: 'Your notifications has failed to load. Please contact admin for support.',
  createdOn: new Date(),
  read: undefined,
};

export const notification: notifications[] = [
  {
    id: 1,
    title: 'Admin',
    message: 'Your application is in review',
    createdOn: new Date(REVIEWED_AT),
    read: new Date(REVIEWED_AT),
  },
  {
    id: 2,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date('2023-10-02T12:00:00Z'),
    read: undefined,
  },
  {
    id: 3,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date('2023-10-02T23:00:00Z'),
    read: new Date(REVIEWED_AT),
  },
  {
    id: 4,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date(LATE_CREATED_AT),
    read: new Date(LATE_READ_AT),
  },
  {
    id: 5,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date(LATE_CREATED_AT),
    read: new Date(LATE_READ_AT),
  },
  {
    id: 6,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date(LATE_CREATED_AT),
    read: new Date(LATE_READ_AT),
  },
  {
    id: 7,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date(LATE_CREATED_AT),
    read: new Date(LATE_READ_AT),
  },
  {
    id: 8,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date(LATE_CREATED_AT),
    read: new Date(LATE_READ_AT),
  },
  {
    id: 9,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date(LATE_CREATED_AT),
    read: new Date(LATE_READ_AT),
  },
  {
    id: 10,
    title: 'Billing',
    message: SUPPORTING_TEXT,
    createdOn: new Date(LATE_CREATED_AT),
    read: new Date(LATE_READ_AT),
  }
];